import { MdAccountBalanceWallet, MdBarChart, MdCategory, MdDescription, MdHome, MdLock, MdPix, MdPin } from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/access/default';
import Orders from 'views/access/orders';

// Auth Imports
import { BiHourglass } from 'react-icons/bi';
import { BsPhoneFlip, BsSafe2 } from 'react-icons/bs';
import { FaExclamationTriangle, FaFileInvoiceDollar, FaHeart, FaIdCard, FaLayerGroup, FaLink, FaReceipt } from 'react-icons/fa';
import { FiSettings } from 'react-icons/fi';
import { IoCashOutline } from 'react-icons/io5';
import { LuBoxes } from 'react-icons/lu';
import { PiRepeat, PiUsersFour, PiCalendarCheck } from 'react-icons/pi';
import Balances from 'views/access/balances/balances';
import BalancesPending from 'views/access/balances/balances-pending';
import FeesSummary from 'views/access/balances/fees-summary';
import ReceivedSplits from 'views/access/balances/received-splits';
import CardsPage from 'views/access/card/CardsPage';
import Chargebacks from 'views/access/chargebacks';
import Charges from 'views/access/charges';
import Deposit from 'views/access/deposit';
import ChargesBatch from 'views/access/charges-batch';
import ChargesBatchItems from 'views/access/charges-batch/Items';
import ContractsListPage from 'views/access/contracts';
import Charge from 'views/access/charges/Charge';
import CatalogGroups from 'views/access/catalog/groups';
import CatalogGroupProducts from 'views/access/catalog/products';
import Clients from 'views/access/clients';
import Settings from 'views/access/customers/settings';
import Insurances from 'views/access/insurances';
import Terminals from 'views/access/maquinetas';
import Movement from 'views/access/orders/Movement';
import LinksRecurrency from 'views/access/recurrences/list-links';
import Recurrency from 'views/access/recurrences/list-recurrences';
import RecurrencesPlans from 'views/access/recurrences/plans';
import ShowRecurrence from 'views/access/recurrences/ShowRecurrence';
import Terminais from 'views/access/terminais';
import Withdrawals from 'views/access/withdrawals';
import WithdrawalApprovals from 'views/access/withdrawals/approvals';
import ScheduledWithdrawals from 'views/access/withdrawals/scheduled';
import ScheduledChargesPage from 'views/access/scheduled-charges';
import WithdrawalsBatch from 'views/access/withdrawals-batch';
import WithdrawalsBatchItems from 'views/access/withdrawals-batch/Items';
import WithdrawalsBatchUpload from 'views/access/withdrawals-batch/Upload';
import PixPayment from 'views/access/pix';
import PixKeyPage from 'views/access/pix/PixKeyPage';
import PixQrCodePage from 'views/access/pix/PixQrCodePage';
import PixBankDataPage from 'views/access/pix/PixBankDataPage';
import PixFavoredPage from 'views/access/pix/PixFavoredPage';
import FavoritesPage from 'views/access/favorites';
import ConsolidatedReport from 'views/access/reports/consolidated';
import Register from 'views/auth/register';
import AddressRegister from 'views/auth/register/address';
import CompanyRegister from 'views/auth/register/company';
import CompletedOnboarding from 'views/auth/register/complete';
import CredentialsRegister from 'views/auth/register/credentials';
import DocumentsOnboarding from 'views/auth/register/documents';
import HolderRegister from 'views/auth/register/holder';
import SignIn from 'views/auth/signIn';
import Privacy from 'views/auth/signIn/privacy';
import { getVariable } from 'whitelabel';

export const getRoutesConfig = (): RoutesType[] => [
  {
    name: 'Dashboard',
    layout: '/access',
    pathPrevious: '/access/dashboard',
    namePrevious: 'Início',
    path: '/dashboard',
    icon: MdHome,
    component: <MainDashboard />,
  },
  {
    name: 'Vendas',
    layout: '/access',
    icon: MdBarChart,
    path: '/transactions',
    component: <Orders />,
  },
  {
    name: 'Chargebacks',
    layout: '/access',
    icon: FaExclamationTriangle,
    path: '/chargebacks',
    component: <Chargebacks />,
  },
  {
    name: 'Cobrança',
    layout: '/access',
    icon: MdBarChart,
    path: '/charge/:id',
    hideOnSideBar: true,
    component: <Charge />,
  },
  {
    name: 'Cobranças',
    layout: '/access',
    path: '',
    icon: FaFileInvoiceDollar,
    children: [
      {
        name: 'Cobranças',
        layout: '/access',
        icon: FaFileInvoiceDollar,
        path: '/charges',
        component: <Charges />,
      },
      {
        name: 'Em Lote',
        layout: '/access',
        icon: FaLayerGroup,
        path: '/charges-batch',
        companyFeature: 'charges_batch_enabled',
        component: <ChargesBatch />,
      },
      {
        name: 'Itens do Lote',
        layout: '/access',
        icon: FaLayerGroup,
        path: '/charges-batch/:id',
        hideOnSideBar: true,
        component: <ChargesBatchItems />,
      },
      {
        name: 'Recorrências',
        layout: '/access',
        path: '',
        icon: PiRepeat,
        featureFlag: 'recurrencyEnabled',
        children: [
          {
            name: 'Clientes',
            layout: '/access',
            icon: PiUsersFour,
            path: '/clients',
            component: <Clients />,
          },
          {
            name: 'Recorrências ',
            layout: '/access',
            icon: FaReceipt,
            path: '/recurrences',
            component: <Recurrency />,
          },
          {
            name: 'Produtos',
            layout: '/access',
            icon: LuBoxes,
            path: '/recurrence-plans',
            component: <RecurrencesPlans />,
          },
          {
            name: 'Consultar Recorrência',
            layout: '/access',
            hideOnSideBar: true,
            icon: FaReceipt,
            path: '/recurrence/:id',
            component: <ShowRecurrence />,
          },
          {
            name: 'Links de Recorrência',
            layout: '/access',
            icon: FaLink,
            path: '/recurrence-links',
            component: <LinksRecurrency />,
          },
        ],
      },
    ],
  },
  {
    name: 'Depositar',
    layout: '/access',
    icon: IoCashOutline,
    path: '/deposit',
    customerFeature: 'deposit',
    component: <Deposit />,
  },
  {
    name: 'Cobranças programadas',
    layout: '/access',
    icon: PiRepeat,
    path: '/cobrancas-programadas',
    component: <ScheduledChargesPage />,
  },
  {
    name: 'Saldos',
    layout: '/access',
    icon: MdAccountBalanceWallet,
    children: [
      {
        name: 'Liberados',
        layout: '/access',
        icon: MdAccountBalanceWallet,
        path: '/balances',
        component: <Balances />,
      },

      {
        name: 'Pendentes',
        layout: '/access',
        icon: BiHourglass,
        path: '/balance-pending',
        component: <BalancesPending />,
      },
      {
        name: 'Resumo de taxas',
        layout: '/access',
        icon: MdAccountBalanceWallet,
        path: '/fees-summary',
        customerFeature: 'feesSummary',
        component: <FeesSummary />,
      },
      {
        name: 'Splits recebidos',
        layout: '/access',
        icon: MdAccountBalanceWallet,
        path: '/received-splits',
        customerFeature: 'feesSummary',
        component: <ReceivedSplits />,
      },
    ],
  },
  {
    name: 'Relatórios',
    layout: '/access',
    icon: MdBarChart,
    children: [
      {
        name: 'Extrato Consolidado',
        layout: '/access',
        icon: MdBarChart,
        path: '/reports/consolidated',
        component: <ConsolidatedReport />,
      },
    ],
  },

  {
    name: 'Movimento',
    layout: '/access',
    icon: MdBarChart,
    path: '/transactions/:id',
    hideOnSideBar: true,
    component: <Orders />,
  },
  {
    name: 'Seguros',
    layout: '/access',
    isAdmin: true,
    icon: BsSafe2,
    path: '/insurances',
    featureFlag: 'insuranceEnabled',
    component: <Insurances />,
  },

  {
    name: 'Pix por Chave',
    layout: '/access',
    icon: MdPix,
    path: '/pix/dict',
    hideOnSideBar: true,
    pathPrevious: '/access/pix',
    namePrevious: 'Pagar com Pix',
    component: <PixKeyPage />,
  },
  {
    name: 'Pix Copia e Cola',
    layout: '/access',
    icon: MdPix,
    path: '/pix/qrcode',
    hideOnSideBar: true,
    pathPrevious: '/access/pix',
    namePrevious: 'Pagar com Pix',
    component: <PixQrCodePage />,
  },
  {
    name: 'Dados Bancários',
    layout: '/access',
    icon: MdPix,
    path: '/pix/manu',
    hideOnSideBar: true,
    pathPrevious: '/access/pix',
    namePrevious: 'Pagar com Pix',
    component: <PixBankDataPage />,
  },
  {
    name: 'Favoritos',
    layout: '/access',
    icon: MdPix,
    path: '/pix/favored',
    hideOnSideBar: true,
    pathPrevious: '/access/pix',
    namePrevious: 'Pagar com Pix',
    component: <PixFavoredPage />,
  },
  {
    name: 'Saques',
    layout: '/access',
    icon: IoCashOutline,
    children: [
      {
        name: 'Saques',
        layout: '/access',
        icon: IoCashOutline,
        path: '/saques',
        component: <Withdrawals />,
      },
      {
        name: 'Agendados',
        layout: '/access',
        icon: PiCalendarCheck,
        path: '/pagamentos-agendados',
        component: <ScheduledWithdrawals />,
      },
      {
        name: 'Aprovações',
        layout: '/access',
        icon: IoCashOutline,
        path: '/saques-aprovacao',
        pathPrevious: '/access/saques',
        namePrevious: 'Saques',
        component: <WithdrawalApprovals />,
      },
      {
        name: 'Em Lote',
        layout: '/access',
        icon: FaLayerGroup,
        path: '/withdrawals-batch',
        companyFeature: 'withdrawals_batch_enabled',
        component: <WithdrawalsBatch />,
      },
      {
        name: 'Novo lote',
        layout: '/access',
        icon: FaLayerGroup,
        path: '/withdrawals-batch/new',
        hideOnSideBar: true,
        component: <WithdrawalsBatchUpload />,
      },
      {
        name: 'Itens do Lote',
        layout: '/access',
        path: '/withdrawals-batch/:id',
        hideOnSideBar: true,
        component: <WithdrawalsBatchItems />,
      },
      {
        name: 'Favorecidos',
        layout: '/access',
        icon: FaHeart,
        path: '/favorecidos',
        component: <FavoritesPage />,
      },
      {
        name: 'Pagar com Pix',
        layout: '/access',
        icon: MdPix,
        path: '/pix',
        component: <PixPayment />,
      },
    ],
  },
  {
    name: 'Venda',
    layout: '/access',
    icon: MdBarChart,
    path: '/movement/:id',
    pathPrevious: '/access/transactions',
    namePrevious: 'Vendas',
    component: <Movement />,
    hideOnSideBar: true,
  },
  {
    name: `App - ${getVariable('name')}`,
    layout: '/access',
    icon: BsPhoneFlip,
    path: '/terminais',
    featureFlag: 'terminalsEnabled',
    component: <Terminais />,
  },
  {
    name: 'Terminais/Máquinas',
    layout: '/access',
    icon: MdPin,
    path: '/terminals',
    featureFlag: 'terminalsEnabled',
    component: <Terminals />,
  },
  {
    name: 'Cartões',
    layout: '/access',
    icon: FaIdCard,
    path: '/cards',
    featureFlag: 'cardsEnabled',
    component: <CardsPage />,
  },

  {
    name: 'Catálogo',
    layout: '/access',
    path: '',
    icon: MdCategory,
    children: [
      {
        name: 'Grupos',
        layout: '/access',
        icon: MdCategory,
        path: '/catalog/groups',
        component: <CatalogGroups />,
      },
    ],
  },
  {
    name: 'Produtos',
    layout: '/access',
    icon: MdCategory,
    path: '/catalog/groups/:groupId',
    hideOnSideBar: true,
    component: <CatalogGroupProducts />,
  },
  {
    name: 'Configurações',
    layout: '/access',
    icon: FiSettings,
    path: '/settings',
    pathPrevious: '/dashboard',
    namePrevious: 'Início',
    component: <Settings />,
  },
  {
    name: 'Contratos',
    layout: '/access',
    icon: MdDescription,
    path: '/contracts',
    component: <ContractsListPage />,
  },
  {
    name: 'Entrar',
    layout: '/auth',
    hideOnSideBar: true,
    path: '/sign-in',
    icon: MdLock,
    component: <SignIn />,
  },
  {
    name: 'Empresa',
    layout: '/auth',
    hideOnSideBar: true,
    path: '/register/company',
    icon: MdLock,
    component: <CompanyRegister />,
  },
  {
    name: 'Empresa',
    layout: '/auth',
    hideOnSideBar: true,
    path: '/register/holder',
    icon: MdLock,
    component: <HolderRegister />,
  },
  {
    name: 'CompletedOnboarding',
    layout: '/auth',
    hideOnSideBar: true,
    path: '/register/complete',
    icon: MdLock,
    component: <CompletedOnboarding />,
  },
  {
    name: 'Endereço',
    layout: '/auth',
    hideOnSideBar: true,
    path: '/register/address',
    icon: MdLock,
    component: <AddressRegister />,
  },
  {
    name: 'Endereço',
    layout: '/auth',
    hideOnSideBar: true,
    path: '/register/documents',
    icon: MdLock,
    component: <DocumentsOnboarding />,
  },
  {
    name: 'Credenciais',
    layout: '/auth',
    hideOnSideBar: true,
    path: '/register/credentials',
    icon: MdLock,
    component: <CredentialsRegister />,
  },
  {
    name: 'Registrar',
    layout: '/auth',
    hideOnSideBar: true,
    path: '/register',
    icon: MdLock,
    component: <Register />,
  },
  {
    name: 'Política de Privacidade',
    layout: '/auth',
    hideOnSideBar: true,
    path: '/privacy',
    icon: MdLock,
    component: <Privacy />,
  },
];

export default getRoutesConfig;
